import React, { useEffect, useState } from "react";
import { History } from "lucide-react";
import api from "../lib/api";
import { useI18n } from "../lib/i18n";

const fmtDur = (s) => {
  if (!s) return "0s";
  const m = Math.floor(s / 60);
  const sec = s % 60;
  return m > 0 ? `${m}m ${sec}s` : `${sec}s`;
};
const fmtTime = (iso) => new Date(iso).toLocaleString();

const STATUS_STYLE = {
  completed: "text-emerald-400 bg-emerald-400/10 border-emerald-400/20",
  escalated: "text-cyan-accent bg-cyan-accent/10 border-cyan-accent/20",
  missed: "text-rose-400 bg-rose-400/10 border-rose-400/20",
};

export default function CallLogs() {
  const { t } = useI18n();
  const [items, setItems] = useState([]);

  useEffect(() => { (async () => { const r = await api.get("/calls"); setItems(r.data); })(); }, []);

  return (
    <div className="space-y-6" data-testid="calls-page">
      <div>
        <div className="chip"><History className="h-3 w-3" /> {t("calls.title")}</div>
        <h1 className="mt-3 text-3xl lg:text-4xl font-extrabold text-white tracking-tight">{t("calls.title")}</h1>
        <p className="mt-1 text-slate-400 text-sm">{t("calls.sub")}</p>
      </div>

      <div className="glass rounded-2xl overflow-hidden">
        <div className="overflow-x-auto">
          <table className="w-full text-sm">
            <thead className="bg-bg-1 text-[10px] font-bold uppercase tracking-widest text-slate-400">
              <tr>
                <th className="text-left px-5 py-3">{t("calls.caller")}</th>
                <th className="text-left px-5 py-3">{t("calls.status")}</th>
                <th className="text-left px-5 py-3">{t("calls.duration")}</th>
                <th className="text-left px-5 py-3">{t("calls.lang")}</th>
                <th className="text-left px-5 py-3">{t("calls.summary")}</th>
                <th className="text-left px-5 py-3">{t("calls.conf")}</th>
                <th className="text-left px-5 py-3">{t("calls.time")}</th>
              </tr>
            </thead>
            <tbody>
              {items.length === 0 && (
                <tr><td colSpan={7} className="text-center px-5 py-10 text-slate-500">{t("calls.empty")}</td></tr>
              )}
              {items.map((c) => (
                <tr key={c.id} className="border-t border-white/5 hover:bg-white/[0.02]" data-testid={`call-row-${c.id}`}>
                  <td className="px-5 py-3 font-mono text-white">{c.caller_number}</td>
                  <td className="px-5 py-3">
                    <span className={`text-[10px] font-bold uppercase tracking-wider px-2 py-1 rounded-md border ${STATUS_STYLE[c.status] || ""}`}>{c.status}</span>
                  </td>
                  <td className="px-5 py-3 font-mono text-slate-300">{fmtDur(c.duration_sec)}</td>
                  <td className="px-5 py-3 font-mono text-slate-400 uppercase">{c.language}</td>
                  <td className="px-5 py-3 text-slate-300 max-w-md truncate">{c.transcript_summary}</td>
                  <td className="px-5 py-3 font-mono text-magenta">{c.confidence}</td>
                  <td className="px-5 py-3 font-mono text-slate-500 text-xs">{fmtTime(c.started_at)}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );
}
